import { alpha } from '@mui/material/styles';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';

export const toggleButtonOverride = {
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 'auto',
        margin: theme.spacing(0.5),
        color: theme.palette.text.primary,
        border: 0,
        [`&.${toggleButtonGroupClasses.grouped}`]: {
          borderRadius: '2px',
          margin: '4px',
          '&:not(:first-of-type)': {
            borderRadius: '2px',
            margin: '4px',
            marginLeft: 0
          },
          '&:not(:last-of-type)': {
            margin: '4px',
            marginLeft: 0
          },
          '&:first-of-type': {
            borderRadius: '2px',
            margin: '4px'
          }
        },
        '& .MuiSvgIcon-root': {
          color: theme.palette.grey[700],
          width: theme.spacing(2),
          height: theme.spacing(2)
        },
        '&.Mui-focusVisible': {
          backgroundColor: theme.palette.action.focus
        },
        '&.Mui-selected': {
          color: theme.palette.primary.main,
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          '& .MuiSvgIcon-root': {
            color: 'inherit'
          },
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.12)
          },
          '&:focus-visible': {
            backgroundColor: theme.palette.action.focus
          }
        },
        '&.Mui-disabled.Mui-selected': {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.disabledBackground
        },
        '&.Mui-disabled': {
          border: 0
        }
      })
    }
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        height:
          ownerState.size === 'small' ? theme.spacing(3.5) : theme.spacing(4.5),
        [`& .${toggleButtonGroupClasses.grouped}:not(:last-of-type)`]: {
          borderRadius: '2px'
        },
        [`& .${toggleButtonGroupClasses.grouped}:not(:first-of-type)`]: {
          borderRadius: '2px',
          borderLeft: 0,
          marginLeft: 0
        }
      })
    }
  }
};
